import { render, staticRenderFns } from "./QuoteRefrence.vue?vue&type=template&id=42201600&scoped=true"
import script from "./QuoteRefrence.vue?vue&type=script&lang=js"
export * from "./QuoteRefrence.vue?vue&type=script&lang=js"
import style0 from "./QuoteRefrence.vue?vue&type=style&index=0&id=42201600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42201600",
  null
  
)

export default component.exports